import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TranslateText } from "../../../utils/translation";
import { updateShowExtraOptionDrawer } from "../../../reducer/bookingReducer";
import { Button } from "antd";
import { FaChevronRight } from "react-icons/fa";

const ExtraOption = ({ bookingType, isBookingAlterationAllowed }) => {
  const dispatch = useDispatch();

  const { bookingDetails } = useSelector((store) => store.booking);
  const handleEdit = () => dispatch(updateShowExtraOptionDrawer(true));

  const [expandedExtraOption, setExpanedExtraOption] = useState(false);

  return (
    <div className="w-[50%] flex-1 mb-[50px]  relative p-4   border rounded-xl border-[#DCE2ED4D]">
      <div
        className="font-outfit font-[500] flex cursor-pointer justify-between items-center"
        onClick={() => setExpanedExtraOption(!expandedExtraOption)}
      >
        <span className="text-[#222B45] text-[18px] leading-[22px]">
          Other Details
        </span>

        {expandedExtraOption ? (
          isBookingAlterationAllowed ? (
            <Button
              className="border-0 text-[14px] text-[#007FFF] leading-[20px]  "
              onClick={handleEdit}
            >
              <TranslateText textKey={"edit"} namespace="common" />
            </Button>
          ) : (
            <></>
          )
        ) : (
          <FaChevronRight className="text-[20px] text-[#007FFF]" />
        )}
      </div>

      {Boolean(expandedExtraOption) && (
        <div className="flex flex-wrap gap-2 pt-[1rem] text-[14px] text-[#8F9BB3] font-outfit font-[400] ">
          <div className="flex gap-2  bg-[#EDF1F7]  p-2 rounded-md ">
            <span>
              <TranslateText textKey={"arrival"} namespace="booking" />:{" "}
            </span>

            <span className="capitalize">{bookingDetails?.arrival}</span>
          </div>

          <div className="flex gap-2  bg-[#EDF1F7]  p-2 rounded-md ">
            <span>
              <TranslateText textKey={"destination"} namespace="booking" />:
            </span>

            <div className=" capitalize">{bookingDetails?.destination}</div>
          </div>

          <div className="flex gap-2  bg-[#EDF1F7]  p-2 rounded-md ">
            <span>
              <TranslateText textKey={"purpose_of_visit"} namespace="booking" />
              :
            </span>

            <span className="capitalize">{bookingDetails?.purposeOfVisit}</span>
          </div>

          <div className="flex gap-2  bg-[#EDF1F7]  p-2 rounded-md ">
            <span>
              <TranslateText textKey={"remarks"} namespace="booking" />:
            </span>

            <span className="capitalize">{bookingDetails?.remarks ?? ""}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExtraOption;
